import script from "./GifsSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./GifsSelection.vue?vue&type=script&setup=true&lang=ts"

import "./GifsSelection.vue?vue&type=style&index=0&id=8c93ae10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c93ae10"]])

export default __exports__